const reports = {
  share_report: 'Share report',
  share_report_link: 'Report link',
  copied_to_clipboard: 'Copied to clipboard',
  share: 'Copy invitation & close',
  task_description: 'Test prompt',
  see_full_report: 'See full report',
  stop_simulation: 'Stop simulation',
} as const;

export default reports;
